<template>
  <footer class="w-full fundo-principal">
    <div class="flex justify-around">
      <div class="flex flex-row flex-wrap justify-center">
        <img src="@/assets/img/logo_prodam/1.svg" alt="" class="text-black w-full h-16 mx-4 my-2 object-contain">
      </div>
      <div class="flex flex-row flex-wrap items-center justify-center py-1">
        <span class="text-gray-50">{{getAmbiente}}</span>
        <span class="text-gray-50">: {{getVersao}}</span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  computed:{
    getAmbiente(){
      if(process.env.NODE_ENV==="development" && process.env.VUE_APP_AMBIENTE==="Homologação"){
        return "Homologação"
      }else if (process.env.NODE_ENV==="production"){
        return "Produção"
      }else {
        return process.env.VUE_APP_AMBIENTE;
      }
    },
    getVersao(){
      return process.env.VUE_APP_CURRENT_VERSION;
    },
  }
}
</script>

<style scoped>

</style>
